import { render } from "./Dashboard.vue?vue&type=template&id=3e2739ca"
const script = {}

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__